import React from "react";
import PropTypes from "prop-types";
import { formatMass } from "@signolteam/shared/units-of-measure";
import { datetimeTinyFormatterUTC } from "@src/constants/convertions";
import AppUtils from "@src/utils/appUtils";
import { useDCContext } from "@src/context/dcContext";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

import CardContainer from "@src/components/cards/CardContainer";
import JustifyBetweenRow from "@src/components/cards/JustifyBetweenRow";
import { Icon, ImageWithRetry } from "@src/components/atoms";

const RecentEventCard = ({
  event = {},
  onEventClick,
  industry,
  icon,
  trackingActionKey,
}) => {
  const { getDynamicReplacement } = useDCContext();

  const fuelIconURL = getDynamicReplacement(
    "captain__events__behaviour__swiper__fuel_icon",
    {},
  );

  const routeInfo = AppUtils.returnJourneyString(
    event.origin,
    event.destination,
  );
  const start = datetimeTinyFormatterUTC(event.ocurrenceDatetime);
  const end = datetimeTinyFormatterUTC(event.arrivalDatetime);

  const savingNum =
    event?.savings || event.totalFuelSavedKg || event?.totalFuelSaved || 0;

  const urlPathToEventPage = `/dashboard/operator/events/${event.id}`;
  return (
    <CardContainer
      bgColor="primary-100"
      padding={0}
      onClick={() => onEventClick(urlPathToEventPage)}
      trackingObject={
        !!trackingActionKey
          ? {
              actionKey: trackingActionKey,
              newUrl: urlPathToEventPage,
            }
          : undefined
      }
    >
      <JustifyBetweenRow>
        {/* child 1 */}
        {!!industry && industry.toLowerCase() === "aviation" ? (
          <div className="flex items-center flex-[1_1_0%] min-w-0">
            {icon && (
              <Icon
                name={icon.toLowerCase()}
                backgroundColor="white"
                size="2xl"
                centered={false}
                className="mr-3"
              />
            )}
            <div className="flex flex-col min-w-0">
              <span className="font-bold truncate overflow-hidden">
                {routeInfo}
              </span>
              <span className="text-sm">{start}</span>
            </div>
          </div>
        ) : (
          <div className="flex items-center flex-[1_1_0%] min-w-0">
            <div className="flex flex-col min-w-0">
              <span className="font-bold truncate overflow-hidden">
                {routeInfo}
              </span>
              <span className="text-sm">
                {start}
                {" > "}
                {end}
              </span>
            </div>
          </div>
        )}
        {/* child 2 */}
        <div className="flex items-center">
          <ImageWithRetry
            className="h-8 w-auto mr-3"
            src={fuelIconURL}
            alt="fuel icon"
          />
          <div className="flex flex-col">
            <span className="font-bold">
              {formatMass(industry, savingNum, 0, {}).formattedValue}
            </span>
            <span>fuel saved</span>
          </div>
        </div>
      </JustifyBetweenRow>
    </CardContainer>
  );
};

export const recentEventCardControls = {
  event: {
    propType: PropTypes.object,
    description: "Event data object",
    controlType: "object",
  },
  getDynamicContent: {
    propType: PropTypes.func,
    description: "Function to get dynamic content",
    disable: true,
  },
  onEventClick: {
    propType: PropTypes.func,
    description: "Event click handler",
    disable: true,
  },
  industry: COMMON_CONTROLS.industry,
  icon: {
    propType: PropTypes.string,
    description: "Industry",
    controlType: "text",
  },
};

RecentEventCard.propTypes = AppUtils.getPropTypeFromControls(
  recentEventCardControls,
);

export default RecentEventCard;
